import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { Button } from '../common';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative z-10 w-full max-w-md p-6 rounded-xl bg-background-glass border border-white/10 backdrop-blur-md shadow-xl">
        {/* Decorative elements */}
        <div className="absolute -top-12 -right-12 w-24 h-24 bg-primary-500/20 rounded-full filter blur-[30px]" />
        <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-secondary-500/20 rounded-full filter blur-[30px]" />
        
        {/* Modal Header */}
        <div className="flex items-center mb-4">
          <div className="p-3 rounded-full bg-red-500/20 mr-4">
            <FiAlertTriangle className="text-red-400 text-xl" />
          </div>
          <h3 className="text-xl font-bold text-white">Confirm Logout</h3>
        </div>
        
        {/* Modal Body */}
        <div className="mb-6">
          <p className="text-white/80">
            Are you sure you want to log out of your SpeedMeet account? You will need to log in again to access your meetings and account information.
          </p>
        </div>
        
        {/* Modal Footer */}
        <div className="flex justify-end space-x-3">
          <Button
            variant="glass"
            size="sm"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            size="sm"
            glowEffect
            onClick={onConfirm}
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal;
